


























import Vue from 'vue';
import Component from 'vue-class-component';
import firebase from 'firebase';
import store from '@/store/store';
import { User } from '@/types';
import { getModule } from 'vuex-module-decorators';
import Auth from '@/store/modules/auth';
import Dialog from '@/store/modules/dialog';

const authModule = getModule(Auth, store);
const dialogModule = getModule(Dialog, store);

@Component({
  props: { value: Boolean },
  computed: {
    open: {
      get() {
        return dialogModule.isSignInDialogOpen;
      },
      set(isOpen) {
        dialogModule.openSignInDialog({ open: isOpen });
      },
    },
  },
})
export default class SignInDialog extends Vue {
  async signInWithGoogle() {
    this.$emit('close');
    await authModule.signInWithGoogle();
  }

  async signInWithTwitter() {
    this.$emit('close');
    await authModule.signInWithTwitter();
  }

  async signInWithFacebook() {
    this.$emit('close');
    await authModule.signInWithFacebook();
  }
}
